import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import axios from 'axios';
import { notificationContainer } from 'utils/notificationContainer';
import { api } from 'services/api';
import {
	TEmVatCorrectionsImportListRequest,
	TEmVatCorrectionsImportListResponse,
	TLoadOrderVatCorrectionsForOrderRequestPayload,
} from './types';
import {
	loadEmVatCorrectionsImportListRequest,
	loadEmVatCorrectionsImportListSuccess,
	loadEmVatCorrectionsImportListFailure,
	loadOrderVatCorrectionsForOrderRequest,
	loadOrderVatCorrectionsForOrderSuccess,
	loadOrderVatCorrectionsForOrderFailure,
} from './reducer';
import {
	ORDER_DETAIL_VAT_CORRECTIONS_PAGE_SIZE,
	VAT_CORRECTIONS_CONSOLIDATED_VIEW_TABLE,
} from './constants';

function* loadEmVatCorrectionsImportListWorker(
	action: PayloadAction<TEmVatCorrectionsImportListRequest>,
) {
	try {
		const response: TEmVatCorrectionsImportListResponse = yield call(
			api.emVatCorrectionsImport.loadList,
			action.payload,
		);
		yield put(loadEmVatCorrectionsImportListSuccess(response));
	} catch (error) {
		yield put(loadEmVatCorrectionsImportListFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
	}
}

function* loadOrderVatCorrectionsForOrderWorker(
	action: PayloadAction<TLoadOrderVatCorrectionsForOrderRequestPayload>,
) {
	try {
		const response: TEmVatCorrectionsImportListResponse = yield call(
			api.emVatCorrectionsImport.loadList,
			{
				tableName: VAT_CORRECTIONS_CONSOLIDATED_VIEW_TABLE,
				orderBy: ['id desc'],
				filter: [{ name: 'order_id', value: action.payload.orderId, comparator: '=' }],
				page: { size: ORDER_DETAIL_VAT_CORRECTIONS_PAGE_SIZE, from: 0 },
			},
		);
		yield put(loadOrderVatCorrectionsForOrderSuccess(response));
	} catch (error) {
		yield put(loadOrderVatCorrectionsForOrderFailure());
		if (axios.isAxiosError(error)) {
			notificationContainer(
				String(error?.response?.data?.message ?? error?.response?.data ?? error ?? 'Error'),
				'error',
			);
		}
	}
}

export function* emVatCorrectionsImportSaga() {
	yield takeLatest(
		loadEmVatCorrectionsImportListRequest.type,
		loadEmVatCorrectionsImportListWorker,
	);
	yield takeLatest(
		loadOrderVatCorrectionsForOrderRequest.type,
		loadOrderVatCorrectionsForOrderWorker,
	);
}
